import { gql } from '@apollo/client';

import { useOrgNameQuery } from 'src/generated/mloop-graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OrgNameQuery = gql`
  query OrgName {
    thisOrg {
      id
      name
    }
  }
`;

const useOrgName = (skip?: boolean) => {
  const { data, ...rest } = useOrgNameQuery({
    skip,
  });
  return { orgName: data?.thisOrg?.name, ...rest };
};

export default useOrgName;
